/**
 * @author: subhasish.ghosh@zoom.us
 */

import { legacy_createStore as createStore } from "redux";
import rootReducer from "@redux/reducers/index";

const store = createStore(rootReducer);

export default store;
